import {AfterContentInit, Directive, ElementRef, Input} from '@angular/core';
import {ValidationService} from '../services/validation.service';
import {ResponsiveService} from '../services/responsive.service';

@Directive({
  selector: '[siAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {
  @Input() public siAutoFocus: boolean;
  isDesktop: boolean;

  constructor(
    private el: ElementRef,
    private responsiveService: ResponsiveService
  ) {
    this.setLogic();
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      if (!this.siAutoFocus || !this.isDesktop) {
        return;
      }

      this.el.nativeElement.focus();
    }, 300);
  }

  setLogic(): void {
    this.isDesktop = this.responsiveService.isDesktop();
  }

}
